// import $models from '..'
// import { walkGet } from '@/generic_api/lib/generic_store/vuefire/utils'
// import { walkGetSave } from '@/generic_api/lib'

export default {

  goalIds({ state }) {

    /* Variante 1 - reactivty? Nope :-( */
    // return Object.keys( walkGetSave( state, `res.user.${this.defaultUserId}.goal_settings` ) )

    /* Variante 2 */
    return Object.keys( state.res.user[ this.defaultUserId ].goal_settings )

    /* Variante 3 */
    // return Object.keys( model.getData() )

    /* Variante 4 */
    // return Object.keys( $models.userGoalSettings.getData() )
  }
}
